(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/welcome/assets/javascripts/welcome-new-player-step.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/welcome/assets/javascripts/welcome-new-player-step.js');

'use strict';

const {
  ReactIcon
} = svs.ui;
const WelcomeNewPlayerStepSection = _ref => {
  let {
    icon,
    headline,
    text
  } = _ref;
  return React.createElement("div", {
    className: "marketplace-welcome-stepsection"
  }, React.createElement("div", {
    className: "bg-sport marketplace-welcome-icon"
  }, React.createElement(ReactIcon, {
    class: "icon-inverted",
    color: "white",
    icon: icon,
    size: "600"
  })), React.createElement("h3", {
    className: "f-800"
  }, headline), React.createElement("p", {
    className: "f-400"
  }, text));
};
setGlobal('svs.marketplace.components.welcome.WelcomeNewPlayerStepSection', WelcomeNewPlayerStepSection);

 })(window);